export default "__VITE_ASSET__BsPLION3__"